import React, { useState } from 'react'
import PublicTab from '../../components/publicTabs/PublicTab';
import PrivateTab from '../../components/privateTabs/PrivateTab';
import '../events/Events.css'

const Events = () => {
  const [activeTab, setActiveTab] = useState(0); // Tracks the active tab

  return (
    <div className='dashboard-content-box'>
      <div className="tabs-container events-sec">
        <div className='innerevents-sec'>
          <div className="tabs-header d-flex flex-wrap justify-content-center align-content-center">
            <button  className={`tab-button ${activeTab === 0 ? "active" : ""}`} onClick={() =>  setActiveTab(0)}>
              Public
            </button>
            <button   className={`tab-button ${activeTab === 1 ? "active" : ""}`} onClick={() =>  setActiveTab(1)}>
              Private
            </button>
          </div>

          <div className="tabs-content">
            {activeTab === 0 && (
                <div className="tab-panel">
                    <PublicTab />
                </div>
            )}
            {activeTab === 1 && (
                <div className="tab-panel">
                    <PrivateTab />
                </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Events
